<template>
  <div>
    <Worktemp
      data-aos="fade-down"
      :workTitle="work.tittle"
      :workPara="work.para"
      :companyName="work.company"
      :yearName="work.year"
      :projectType="work.project"
    ></Worktemp>
    <WorkcoverImg :coverimg="work.coverimg" data-aos="fade-up" />
    <section class="singlework container">
      <div class="work-content" data-aos="fade-up">
        <h2>A Simple Idea, Built with Care</h2>
        <p>
          Instead of throwing their hands up in frustration, the team at Swastik
          Foundry decided to take matters into their own hands. They didn't need
          a fancy, off-the-shelf solution; they needed something that understood
          their specific rhythm, their unique way of working. So, they crafted
          their own internal app—a digital tool built with the same care and
          attention to detail as the parts they produced
        </p>
      </div>
    </section>
    <section class="singlework container">
      <div class="work-content" data-aos="fade-up">
        <h2>The Solution with Gentle Touch</h2>
        <h3>Order Oasis</h3>
        <p>
          The app became a calm space amidst the chaos, a place where orders
          were neatly organized and easily accessible. No more hunting through
          stacks of paper, just a clear view of what needed to be done.
        </p>
        <h3>Personal Pockets</h3>
        <p>
          Each team member got their own digital space, a place to keep track of
          their tasks and notes. It was like having a personal assistant, always
          ready to lend a hand.
        </p>
        <h3>No Frills, Just Function</h3>
        <p>
          The app wasn't about flashy graphics or complicated features. It was
          about making life easier, about simplifying the process so the team
          could focus on what they did best.
        </p>
      </div>
    </section>
    <section class="singlework container">
      <div class="work-content" data-aos="fade-up">
        <h2>The Quiet Results</h2>
        <h3>Time Gained Back</h3>
        <p>
          Suddenly, there was more time for the things that mattered. The team
          could focus on crafting quality parts, not chasing down paperwork.
        </p>
        <h3>Mistakes Minimized</h3>
        <p>
          The app became a reliable source of information, reducing the chances
          of errors and miscommunications.
        </p>
        <h3>A Smoother Flow</h3>
        <p>
          The workshop hummed with a new rhythm, a sense of calm and efficiency
          that made everyone's day a little better.
        </p>
      </div>
    </section>
    <section class="singlework container">
      <div class="work-content" data-aos="fade-up">
        <h2>The Heart of the Matter</h2>
        <p>
          Swastik Foundry's story isn't about grand technological feats; it's
          about the power of simple solutions. It's about recognizing a problem
          and finding a way to fix it, step by step. It's a reminder that even
          in the smallest workshops, a little bit of ingenuity can make a big
          difference.
        </p>
        <p>
          Sometimes, the best tools are the ones you build yourself, tailored to
          your own unique needs. And sometimes, the simplest solutions are the
          ones that make the biggest impact.
        </p>
      </div>
    </section>

    <WorkTwoImg :TwoImgleft="work.TwoImgleft" :TwoImgRight="work.TwoImgRight" />
    <WorkThreeImg
      :ThreeImgleft="work.ThreeImgleft"
      :ThreeImgRight="work.ThreeImgRight"
    />
    <WorkcoverImg :coverimg="work.coverimg2" />
    <hire />
  </div>
</template>
<script>
import Worktemp from "@/components/Worktemp.vue";
import WorkcoverImg from "@/components/WorkcoverImg.vue";
import WorkTwoImg from "@/components/WorkTwoImg.vue";
import WorkThreeImg from "@/components/WorkThreeImg.vue";
export default {
  components: {
    Worktemp,
    WorkcoverImg,
    WorkTwoImg,
    WorkThreeImg,
  },
  data() {
    return {
      work: {
        tittle: "Swastik Foundry",
        para: "Imagine a small workshop, Swastik Foundry, where skilled hands crafted parts with precision. But behind the scenes, a different kind of challenge was brewing: the rising tide of bulk orders. Every order meant more paperwork, more frantic calls, more chances for something to slip through the cracks. It was a headache that threatened to overshadow the joy of creation.  Huge thanks to the Cobold team! Their amazing development and flawless delivery made my work as UX designer a breeze. ",
        company: "Swastik Foundry",
        year: "2021",
        project: "Application UI Design",
        coverimg: "/img/gallery/ui/swastik/cover.jpg",
        TwoImgleft: "/img/gallery/ui/swastik/twoleft.svg",
        TwoImgRight: "/img/gallery/ui/swastik/tworight.svg",
        ThreeImgleft: "/img/gallery/ui/swastik/threeleft.svg",
        ThreeImgRight: "/img/gallery/ui/swastik/threeright.svg",
        // coverimg2: "/img/gallery/ui/zsites-landing/cover2.jpg",
      },
    };
  },
};
</script>
